import React, {useEffect, useState} from "react";
import general, { redux } from "../../../general";
import {Link} from "react-router-dom";
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Pagination} from "swiper";
import {useScroll, useMount, useLockFn} from "ahooks";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import useActiveState from '../../../lib/useActiveState';
import {NavLink} from "../../../lib/Navigation";
import Subtitle from "../../components/Subtitle";
import Manager from "../../components/Manager";
import { data } from "jquery";

SwiperCore.use([Pagination]);

export default ({active, type, setTag}) => {
  const [hot_cate, sethot_cate] = useState([]);
  const [gameGroups, setGameGroups] = useState([]);
  const [obsolete, setObsolete] = useState();
  const [user] = useActiveState('user');
  const [agent] = useActiveState('agent');
  const [randomColorInfo] = useActiveState('randomColorInfo');
  const [infoTextColor, setInfoTextColor] = useState();

  const load = useLockFn(async () => {
    Dialog.loading();
    general.axios.post('/base/game/getTypeGames', {
      game_classify_type: -1,
      game_species_type: type,
    })
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let {status, data} = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        setInfoTextColor(randomColorInfo[parseInt(Math.random() * 4)]);
        sethot_cate(data.hot_cate);
        setGameGroups(data.game_cate);
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  });

  useMount(() => load());
  useEffect(() => {
    if (active) {
      load({page: 1});
    } else {
      setObsolete(true);
    }
  }, [type]);
  useEffect(() => {
    if (active && obsolete) {
      load({page: 1});
    }
  }, [active, obsolete]);

  const scroll = useScroll();
  useEffect(() => {
    if (active) {
      if (scroll.top < -80) {
        load({page: 1});
      }
    }
  }, [active, scroll]);

  //分类游戏点击埋点
  const clickTheGameOfCategories = (item) => {
    
  }

  //精选banner点击埋点
  const clickFeaturedBannerOfGameHall = (item) => {
    Manager.push({event_id:'A-2-34-2'})
  }

  return <div className="game-good">
    <div>
      {hot_cate.length > 0 && <div style={{
        fontSize:'.34rem',
        fontWeight:'bold',
        color:'#282828'
      }}>热门分类</div>}
      <div className="hotcate" style={{
      display:'flex',
      flexWrap:'wrap',
      padding:'15px 0'
    }}>
      {hot_cate.map((item,index)=><div
       onClick={()=>{
        redux.dispatch({
          type: 'type',
          data: {
            screenRouter: {
              type: 0,
              tag: item.game_classify_id,
            },
          }
        })
       }}
       style={{
        backgroundColor:'white',
        borderRadius:'8px',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        padding:'8px 0',
        width:'calc(calc(100% - 20px) / 3)',
        marginRight:index % 3 < 2 ? '10px' : '0',
        marginTop:index > 2 ? '10px' : '0'
      }}>
        <img src={item.game_classify_icon} height={30} alt="" />
        <div>{item.game_classify_name}</div>
      </div>)}
    </div>
    </div>
    <div className="groups">
      {gameGroups.map(group => <div className="group">
        <div className="head">
          <div className="name">{group.game_classify_name}</div>
          {(()=>{
            if(group.type == 'special') {
              return <NavLink to={"/game/project?id=" + group.specialId} user={false} className="more">更多</NavLink>
            } else if(group.type == 'tag') {
              return <div className="more" onClick={() => setTag(group.game_classify_id)}>更多</div>
            }
          })()}
          {/* <div className="more" onClick={() => setTag(group.game_classify_id)}>更多 ></div> */}
        </div>
        <div className="body clearfix">
          {[group.game_list[0], group.game_list[1], group.game_list[2], group.game_list[3], group.game_list[4], group.game_list[5]].map(game => game  ? <Link to={'/game?id=' + game.game_id} className="item" onClick={()=>clickTheGameOfCategories(game.game_name)}>
            <div className="icon">
              <Image src={game.game_image.thumb}/>
            </div>
            <div className="name">{game.game_name}</div>
            <div className="info1">{game.game_classify_type.trim().replace(' ',' · ')}</div>
          </Link> : null)}
        </div>
      </div>)}
    </div>
    {gameGroups.length > 6 ? <div className="view-end">更多游戏 请搜索查找</div> : null}
  </div>;
};